import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { DateIsAPair, DateIsAWhat } from '../date-is-a/date-is-a.component';
import { DateUtil } from 'src/app/model/dateutil';
import { SearchCriterion, CriterionEvent, ICriterionComponent, SearchCriteriaRegistrant } from 'src/app/types/search-criteria';


export interface DateKind {
  isA: DateIsAPair;
  weekStart: number;
}

@Component({
  selector: 'app-date-kind',
  templateUrl: './date-kind.component.html',
  styleUrls: ['./date-kind.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DateKindComponent implements OnInit, ICriterionComponent {

  private _isA: DateIsAPair = { what: 'dow', which: 0 };
  public set isA(val: DateIsAPair) {
    if (val.what === this._isA.what) {
      if (val.which === this._isA.which) {
        return;
      }
    }
    this._isA = val;
    this.valueChange.emit(this.value);
    this.Refresh();
  }
  public get isA(): DateIsAPair {
    return this._isA;
  }
  private _what: DateIsAWhat = 'dow';
  public set what(val: DateIsAWhat) {
    if (this._what === val) return;
    this._what = val;
    this.valueChange.emit(this.value);
    this.Refresh();

  }
  public get what(): DateIsAWhat {
    return this._what;
  }
  public which = 0;

  private _weekStart = 0;
  public set weekStart(start: number) {
    if (this._weekStart !== start) {
      this._weekStart = start;
      this.valueChange.emit(this.value);
      this.Refresh();
    }
  }
  public get weekStart(): number {
    return this._weekStart;
  }

  @Output()
  public registrantReady = new EventEmitter<SearchCriteriaRegistrant>();


  private _field = '';
  @Input()
  public set field(value) {
    this._field = value;
    this.Refresh();
  }
  public get field() {
    return this._field;
  }

  @Output()
  public criteriaChange = new EventEmitter<CriterionEvent>();


  @Input()
  public get value(): DateKind {
    return {
      isA: this.isA,
      weekStart: this.weekStart
    }
  }
  public set value(val: DateKind) {
    if (val) {
      this.isA = val.isA;
      this.weekStart = val.weekStart;
      this.cdr.markForCheck();
      this.Refresh();
    }
  }
  @Output()
  public valueChange = new EventEmitter<DateKind>();


  private _filtered: boolean = false;
  @Input()
  public set filtered(isFiltered: boolean) {
    this._filtered = isFiltered;
    this.Refresh();
  }
  public get filtered(): boolean {
    return this._filtered;
  }



  private _ready = false;
  constructor(private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    const now = new Date();
    this.which = +DateUtil.GetDayOfWeek(now);
    this.registrantReady.emit({ field: this.field, component: this })
    this._ready = true;
  }
  Refresh() {
    if (this._ready) {
      this.cdr.detectChanges();
    }
  }
  UpdatePair() {
    this._isA.what = this.what;
    this._isA.which = this.which;
    this.valueChange.emit(this.value);
    this.criteriaChange.emit({
      target: this,
      value: this.value,
      criterion: this.ToCriterion()
    });
    this.Refresh();

  }
  ToCriterion(field?: string, operator?: any): SearchCriterion | null {
    if (!field) {
      field = this.field;
    }
    if (field === '') {
      return null;
    }
    if (!operator) operator = 'date-is-a';
    let val = this.isA.which;
    switch (this.isA.what) {
      case 'dom':
        val = this.isA.which;
        val = Math.min(val, 31);
        val = Math.max(val, 0);
        break;
      case 'dow':
        val = (this.weekStart + this.isA.which - 1) % 7;
        break;
      case 'doy':
        val = this.isA.which;
        val = Math.min(val, 365);
        val = Math.max(val, 0);
        break;
      case 'moy':
        val = this.isA.which;
        val = Math.min(val, 11);
        val = Math.max(val, 0);
        break;
      case 'woy':
        val = this.isA.which;
        val = Math.min(val, 52);
        val = Math.max(val, 0);
        break;
    }
    const criterion: SearchCriterion = {
      field: (field),
      compare: operator,
      value: (val),
      modifier: this.isA.what,
      casting: 'date'
    }
    return criterion;
  }

}
